module.exports = __webpack_public_path__ + "img/login_background.ecfc5ecf.jpg";